import React from 'react';
import { FadeIn } from './FadeIn';
export function StorySection() {
  return <section className="py-24 bg-cream" data-id="element-383">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-384">
        <FadeIn data-id="element-385">
          <div className="prose prose-lg md:prose-xl text-gray-700 mx-auto" data-id="element-386">
            <p className="first-letter:text-6xl first-letter:font-serif first-letter:text-sage first-letter:mr-3 first-letter:float-left leading-relaxed mb-8" data-id="element-387">
              Te despiertas un lunes por la mañana y lo primero que sientes es
              esa presión familiar en el abdomen. No es grasa, es una hinchidez
              rígida que te hace sentir pesada, cansada y con una neblina mental
              que ni tres cafés logran disipar.
            </p>
            <p className="leading-relaxed mb-16" data-id="element-388">
              Intentas abrocharte el pantalón y la incomodidad te recuerda, una
              vez más, que tu cuerpo está en guerra consigo mismo. Sabes que
              algo no va bien, pero las dietas "sanas" parecen no hacer nada.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-389">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-mint/50 relative overflow-hidden" data-id="element-390">
            <div className="absolute top-0 left-0 w-2 h-full bg-sage" data-id="element-391"></div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-392">
              No es tu culpa. Y no es "normal".
            </h2>

            <div className="space-y-6 text-gray-700 text-lg" data-id="element-393">
              <p data-id="element-394">
                La mayoría de las personas creen que estar hinchada es normal
                por la edad o el estrés. No lo es. Lo que experimentas es una
                respuesta inmune de <strong data-id="element-395">"alerta roja"</strong> en tu
                intestino.
              </p>
              <p data-id="element-396">
                Tu cuerpo está reteniendo litros de líquido inflamatorio para
                intentar diluir toxinas y proteger tus órganos. Por eso, aunque
                comas ensaladas y tomes agua, tu abdomen sigue pareciendo un
                globo a punto de explotar al final del día.
              </p>
              <p className="font-medium text-forest text-xl italic mt-4" data-id="element-397">
                Estás viviendo con un incendio interno que consume tu energía y
                arruina tu confianza.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}